export function ehRecusaDefinitivaDeTerminal(erro: unknown) {
  return statusHttp(erro) === 403;
}

export function aoFalharValidacaoTokenTerminal(erro: unknown, limparToken: () => void) {
  if (ehRecusaDefinitivaDeTerminal(erro)) {
    limparToken();
  }
}

export function mensagemFalhaValidacaoTerminal(erro: unknown) {
  if (ehRecusaDefinitivaDeTerminal(erro)) {
    return 'Terminal nao autorizado. Informe o codigo de ativacao.';
  }

  return 'Servidor indisponivel. A ativacao desta estacao foi mantida.';
}

function statusHttp(erro: unknown) {
  if (!erro || typeof erro !== 'object' || !('status' in erro)) {
    return undefined;
  }

  const status = (erro as { status?: unknown }).status;
  return typeof status === 'number' ? status : undefined;
}
